export default __webpack_public_path__ + "Banner.mp4";